<ng-container>
  <div class="mb-6 page-padding-x" id="section-committee-updates">
    <div class="flex flex-row items-center justify-between">
      <div class="flex items-center">
        <h2 id="heading-committee-updates">Latest News</h2>
      </div>

    </div>
  </div>

  <ng-container>
    <div *ngIf="loading" class="flex justify-center" id="loading-spinner-committee-updates">
      <mat-progress-spinner mode="indeterminate" diameter="50">
      </mat-progress-spinner>
    </div>

    <app-update-scroller *ngIf="!loading && newsList"
      [title]="'Latest News'"
      [updateCount]="newsList.length"
      id="scroller-news-updates"
    >
      <a
        *ngFor="let news of newsList"
        [href]="getNewsUrl(news.fieldData.slug)"
        target="_blank"
        [id]="'card-news-updates-' + news.id"
      >
        <div class="flex flex-col">
          <div class="h-40">
            <img *ngIf="news.fieldData.image.url" [src]="news.fieldData.image.url" [alt]="news.fieldData.slug" />
            <div *ngIf="!news.fieldData.image.url" class="flex items-center justify-center h-full align-middle bg-blue-700"><app-sa-logo></app-sa-logo></div>
          </div>
          <div class="">
              <app-update-scroller-card
              [title]="news.fieldData.name"
              [description]="news.fieldData.name"
              >
              <div headerLeft name="date">
                {{ news.customPublishDate | dateFormat }}
              </div>

              </app-update-scroller-card>
          </div>
        </div>
      </a>


    </app-update-scroller>

    <div *ngIf="!loading && newsList?.length == 0"
      class="p-5 ml-10 font-bold bg-white rounded-lg page-padding-s w-80 shadow-cardShadow h-36 card-size"
      id="message-no-committee-updates">
      There are no new news for your committees at this time.
    </div>
  </ng-container>
</ng-container>
